import React from 'react';
import { Settings, Users, Database, ShieldCheck, Activity } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = ({ db, user }) => {
  const navigate = useNavigate();

  const stats = [
    { label: 'System Configurations', icon: Settings, value: 'Active', path: '/admin/settings', color: '#3b82f6' },
    { label: 'User Management', icon: Users, value: 'Controlled', path: '#', color: '#10b981' },
    { label: 'Database Health', icon: Database, value: 'Healthy', path: '#', color: '#f59e0b' },
    { label: 'Security Protocols', icon: ShieldCheck, value: 'Strict', path: '#', color: '#ef4444' },
  ];

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
          <ShieldCheck size={28} color="#2563eb" /> Admin Command Center
        </h2>
        <p style={{ margin: '5px 0 0', color: '#64748b', fontSize: '14px' }}>
          Manage global configurations, user roles, and system metadata.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px', marginBottom: '40px' }}>
        {stats.map((stat, idx) => (
          <div 
            key={idx} 
            onClick={() => navigate(stat.path)}
            style={{ 
              backgroundColor: 'white', padding: '25px', borderRadius: '12px', 
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)', cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s',
              border: '1px solid #e2e8f0'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0,0,0,0.1)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '15px' }}>
              <div style={{ padding: '10px', backgroundColor: `${stat.color}15`, borderRadius: '10px' }}>
                <stat.icon size={24} color={stat.color} />
              </div>
              <span style={{ fontSize: '12px', fontWeight: 'bold', color: stat.color, textTransform: 'uppercase' }}>{stat.value}</span>
            </div>
            <h3 style={{ margin: 0, fontSize: '16px', color: '#1e293b' }}>{stat.label}</h3>
          </div>
        ))}
      </div>

      <div style={{ backgroundColor: '#f8fafc', border: '1px dashed #cbd5e1', borderRadius: '12px', padding: '40px', textAlign: 'center' }}>
        <Activity size={48} color="#94a3b8" style={{ marginBottom: '15px', opacity: 0.5 }} />
        <h3 style={{ margin: 0, color: '#475569' }}>System Logs & Activity</h3>
        <p style={{ color: '#64748b', fontSize: '14px', maxWidth: '400px', margin: '10px auto' }}>
          This section will eventually show real-time changes made by various team members for audit purposes.
        </p>
      </div>
    </div>
  );
};

export default AdminDashboard;
